<p-dialog header="Settings" [(visible)]="applicationConfigurationVisible" modal="modal" [style]="{width: '50vw'}">
    <div fxLayout="column">
        <div fxLayout="row">
            <h4 fxFlex="1 1 30%">Avatar Image: </h4>
            <p-fileUpload fxFlex="1 1 70%" name="demo[]" chooseLabel="Choose" customUpload="true"
                (uploadHandler)="handleAvatarUpload($event)" accept="image/jpeg" maxFileSize="10000000">
            </p-fileUpload>
        </div>
        <!-- <h4>Client Names</h4> 
        <p-fileUpload name="clientnamefile[]" chooseLabel="Choose" auto="true" customUpload="true" (uploadHandler)="handleClientNameUpload($event)" accept="text/csv"
            maxFileSize="10000000">
        </p-fileUpload> -->
        <div fxLayout="row">
            <h4 fxFlex="1 1 30%">Show Environment Identifier: </h4>
            <p-checkbox fxFlex="1 1 70%" [(ngModel)]="appConfig.showApplicationIdentifiers" binary="true"
                (onChange)="onShowApplicationIdentifiersChanged($event)" inputId="showApplicationIdentifiers">
            </p-checkbox>
        </div>
        <div fxLayout="row">
            <h4 fxFlex="1 1 30%">Environment Description: </h4>
            <input fxFlex="1 1 70%" type="text" pInputText [(ngModel)]="appConfig.applicationIdentificationDescription"
                (change)="onApplicationIdentificationDescriptionChanged($event)"
                inputId="applicationIdentificationDescription" />
        </div>
        <div fxLayout="row">
            <h4 fxFlex="1 1 30%">Environment Color: </h4>
            <!-- <p-dropdown fxFlex="1 1 70%" [options]="[1,2,3,4,5,6,7,8,9,10,11,12]"
                [(ngModel)]="appConfig.applicationIdentificationColorIndex"
                (change)="onApplicationIdentificationColorIndexChanged($event)"></p-dropdown> -->
            <p-selectButton fxFlex="1 1 70%" class="application-identifier-color-select" [(ngModel)]="appConfig.applicationIdentificationColorIndex"
                (onChange)="onApplicationIdentificationColorIndexChanged($event)" [options]="[
            {index: 1, color:'#f44336'},
            {index: 2, color:'#8bc34a'},
            {index: 3, color:'#2196f3'},
            {index: 4, color:'#ffc107'},
            {index: 5, color:'#9c27b0'},
            {index: 6, color:'#607d8b'},
            {index: 7, color:'#e91e63'},
            {index: 8, color:'#cddc39'},
            {index: 9, color:'#673ab7'},
            {index: 10, color:'#ff5722'},
            {index: 11, color:'#009688'},
            {index: 12, color:'#3f51b5'}
            ]" optionValue="index" [(ngModel)]="appConfig.applicationIdentificationColorIndex">
                <ng-template let-item>
                    <i class="pi pi-circle-on" [style.color]="item.color"></i>
                </ng-template>
            </p-selectButton>
        </div>
        <!-- <p-colorPicker [(ngModel)]="appConfig.applicationIdentificationColor"></p-colorPicker> -->
    </div>
</p-dialog>